
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, InputGroup, Button } from 'react-bootstrap'
import { momentHelper } from './helpers'
import SelectDate from 'component/element/SelectDate'
import SelectObject from 'component/element/SelectObject'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome';
import CKAutocomplete from 'component/element/CKAutocomplete';
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'

import './report.css'
// import { connect } from 'react-redux';

const mockJson = {
  clientList: [
    {
      clientId: 'all',
      clientName: 'ทั้งหมด'
    },
    // {
    //   clientId: 'owner_person',
    //   clientName: 'เจ้าของรถ (บุคคล)'
    // },
    // {
    //   clientId: 'owner_company',
    //   clientName: 'เจ้าของรถ (บริษัท)'
    // },
    // {
    //   clientId: 'insurer',
    //   clientName: 'บริษัทประกัน/เงินสด'
    // }
    {
      clientId: 'cash',
      clientName: 'เงินสด'
    },
    {
      clientId: 'insurer',
      clientName: 'บริษัทประกัน'
    }
  ],

  incomeList: [
    {
      car_registration_no: 'กข 1234',
      chassisNo: '',
      claimNo: '2015-15331-001491',
      ownerName: 'บ.ไทยน้ำทิพย์',
      payerBy: 'วิริยะ',
      carDetail: 'Honda City',
      parkDate: '07/05/2017',
      appointmentDate: '07/05/2017',
      deliverDate: '17/05/2017',
      autionPrice: '110000',
      autionConfirmPrice: '10000',
      quotationPrice: '117967.50',
      finalPrice: '81800.00 ',
      paymentAmount: '81800.00',
      balance: '81800',
      billingDate: '',
      billingNo: '',
      paymentStatusText: 'รับเงินแล้ว',
      paymentDate: ''
    }
  ],
  clientName: 'กรุงเทพประกันภัย',
  updatedDate: '2017',
  listCount: 100
}
class ReportKKCIncome extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      activePage: 1,
      clientId: mockJson.clientList[0].clientId,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: mockJson,
      query: '',
      queryList: [],
      isRange: false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear()
    }
    this.refTableId = 'ReportKKCIncome-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.query,this.state.clientId)
      this.loadIncomeCategory(this.state.year,this.state.clientId)
    }
  }

  loadData(year='',month='',query='',cat='') {
    let {data} = this.state
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadIncomeList(year,month,cat,query,(result)=>{
      data.incomeList = result.data
      this.setState({data:data})
    })
  }

  loadDataRange(start='',end='',query='',cat='') {
    let {data} = this.state
    ReportStore.loadIncomeListRange(start,end,cat,query,(result)=>{
      data.incomeList = result.data
      this.setState({data:data})
    })
  }

  loadIncomeCategory(year='',key='') {
    ReportStore.loadIncomeCategory(year,(result)=>{
      let queryList = []
      if (key==='all') {
        result.data.cash.forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
        result.data.insurer.forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
        // result.data.insurer.forEach(function(item,index) {
        //   queryList.push({
        //     label:item,
        //     value:item
        //   })
        // })
      } else {
        result.data[key].forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
      }
      this.setState({queryList:queryList,query:''})
    })
  }

  getRowTextColor(insurer_id) {
    if (insurer_id==='0'||insurer_id===0||insurer_id==='') {
      return 'color-blue'
    } else {
      return 'color-red'
    }
  }

  getNumberFormat(val) {
    if (val!==''&&val!==undefined&&val!==null&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    }
    return val
  }

  renderBody() {
    let {data} = this.state
    if (data.incomeList.length===0||data.incomeList===undefined) {
      return(<tr><td colSpan={21}>ไม่พบข้อมูล</td></tr>)
    } else {
      return this.state.data.incomeList.map((item,index)=>
        (
          <tr key={index}>
            <td className='text-center'>{index+1}</td>
            <td className='text-center'>{item.work_no}</td>
            <td className='text-center'>{item.entrance_date}</td>
            <td className='text-center color-red'>{item.appointment_date}</td>
            <td className='text-center color-blue'>{item.delivering_date}</td>
            <td className='text-center'>{item.car_registration_no}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.owner_name}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.paid_by}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.car_detail}</td>
            {/* <td className={'text-right'} style={{width:'70px'}}>{this.getNumberFormat(item.auction_price)}</td>
            <td className='text-right color-blue' style={{width:'70px'}}>{this.getNumberFormat(item.confirm_price)}</td>
            <td className='text-right color-green' style={{width:'70px'}}>{item.insurer_id==='0'||item.insurer_id===0||item.insurer_id===''?this.getNumberFormat(item.final_price):''}</td> */}
            <td className={'text-right color-blue'} style={{width:'70px'}}>{this.getNumberFormat(item.excess)}</td>
            <td className={'text-right color-blue'} style={{width:'70px'}}>{this.getNumberFormat(item['50discount'])}</td>
            <td className={'text-right color-blue'} style={{width:'70px'}}>{this.getNumberFormat(item.diff_payment)}</td>
            <td className={'text-right color-blue'} style={{width:'70px'}}>{this.getNumberFormat(item.cash_amount)}</td>
            <td className='text-right' style={{width:'70px'}}>{item.insurer_id==='0'||item.insurer_id===0||item.insurer_id===''?'':this.getNumberFormat(item.quotation_price)}</td>
            <td className='text-right color-red' style={{width:'70px'}}>{item.insurer_id==='0'||item.insurer_id===0||item.insurer_id===''?'':this.getNumberFormat(item.final_price)}</td>
            <td className='text-right color-blue' style={{width:'70px'}}>{this.getNumberFormat(item.received_amount)}</td>
            <td className='text-right color-red' style={{width:'70px'}}>{this.getNumberFormat(item.expense_amount)}</td>
            <td className='text-right color-blue' style={{width:'70px'}}>{this.getNumberFormat(item.profit)}</td>
            <td className='text-right color-red' style={{width:'70px'}}>{this.getNumberFormat(item.balance)}</td>
            <td className='text-center'>{this.getNumberFormat(item.invoice_date)}</td>
            <td className='text-center'>{this.getNumberFormat(item.invoice_no)}</td>
            <td className='text-center'>{this.getNumberFormat(item.payment_status_text)}</td>
            <td className='text-center'>{this.getNumberFormat(item.payment_date)}</td>
          </tr>
        )
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำเดือน '
      text += momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      }
      return text
    }  
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income' style={{width:'2100px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} className='text-center' colSpan={20}>รายงานสรุปค่าใช้จ่ายของรถลูกค้าแต่ละคัน {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center bg-1' rowSpan={2}>ลำดับ</th>
              <th className='text-center bg-1' rowSpan={2}>ใบงาน</th>
              <th className='text-center bg-2' colSpan={3}>วัน-เดือน-ปี</th>
              <th className='text-center bg-1' rowSpan={2}>ทะเบียนรถ</th>
              <th className='text-center bg-1' rowSpan={2}>เจ้าของรถ</th>
              <th className='text-center bg-1' rowSpan={2}>บริษัทประกัน/เงินสด/เครดิต</th>
              <th className='text-center bg-1' rowSpan={2}>รายการซ่อม ชนิดรถ</th>              
              <th className='text-center bg-2' colSpan={7}>รายรับ</th>              
              <th className='text-center bg-3' rowSpan={2}>รวมค่าใช้จ่าย</th>
              <th className='text-center bg-3' rowSpan={2}>รายได้คงเหลือ</th>
              <th className='text-center bg-3' rowSpan={2}>ค้างจ่ายคงเหลือ</th>
              <th className='text-center bg-2' colSpan={4}>ข้อมูลการโอนเงิน</th>
            </tr>
            <tr>
              <th className='text-center bg-1'>รับรถ</th>
              <th className='text-center bg-1'>กำหนดส่ง</th>
              <th className='text-center bg-1'>รถออกจริง</th>
              {/* <th className='text-center bg-2' style={{width:'100px'}}>ราคาประมูลและเงินสด</th>
              <th className='text-center bg-2'>ราคายืนยัน</th>
              <th className='text-center bg-2'>เงินสดยืนยัน</th> */}
              <th className='text-center bg-2' style={{width:'100px'}}>Excess</th>
              <th className='text-center bg-2'>ส่วนต่าง 50%</th>
              <th className='text-center bg-2'>ส่วนต่างลค.จ่าย</th>
              <th className='text-center bg-2'>ลค.เงินสด</th>
              <th className='text-center bg-2'>ราคาเสนอ</th>
              <th className='text-center bg-2'>ราคาคุม</th>
              <th className='text-center bg-3'>รับเงินแล้ว</th>
              <th className='text-center bg-2'>วันที่วางบิล</th>
              <th className='text-center bg-2'>เลขที่วางบิล</th>
              <th className='text-center bg-2'>สถานะ</th>
              <th className='text-center bg-2'>วันรับเงิน</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={9} className='text-center bg-1'>{'รวมรายการรถเข้าซ่อม '+this.getAll()+' รายการ ซ่อมเสร็จ '+this.getSuccess()+' คัน กำลังซ่อม '+this.getNotSuccess()+' คัน'}</th>
              {/* <th className='text-right bg-2'>{this.getSummary('auction_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('confirm_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummaryConfirmCash().toLocaleString(undefined, {maximumFractionDigits: 2})}</th> */}
              <th className='text-right bg-2'>{this.getSummary('excess').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('50discount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('diff_payment').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('cash_amount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('quotation_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('final_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('received_amount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_amount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('profit').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('balance').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='bg-2' colSpan={4}></th>
            </tr>  
          </tfoot>
        </table>
      </div>
    )
  }

  getAll() {
    let {data} = this.state
    return data.incomeList.length
  }

  getSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status>='2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getNotSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status<'2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      let val = item[key] 
      if (val===''||val===null||val===undefined||isNaN(val)) {
        val = 0
      }
      sum = parseFloat(val) + parseFloat(sum)
    })
    return sum
  }

  getSummaryConfirmCash() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.insurer_id==='0'||item.insurer_id===0||item.insurer_id==='') {
        let val = item.final_price
        if (val===''||val===null||val===undefined||isNaN(val)) {
          val = 0
        }
        sum = parseFloat(val) + parseFloat(sum)
      }  
    })
    return sum
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onMonthChange(val) {
    this.setState({
      month: val.value, isRange: false
    })
    this.loadData(this.state.year,val.value,this.state.query,this.state.clientId)
  }

  onYearChange(val) {
    this.setState({
      year: val.value, isRange: false
    })
    this.loadData(val.value,this.state.month,this.state.query,this.state.clientId)
  }

  onClientChange(val) {
    this.loadIncomeCategory(this.state.year,val.value)
    this.setState({clientId: val.value})
  }

  onSearchClick(e) {
    let {isRange,clientId,query,day,month,year,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
      let end = (dayRange<10?'0'+dayRange:dayRange)+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+(yearRange-543)
      this.loadDataRange(start,end,this.state.query,this.state.clientId)
    } else 
      this.loadData(year,month,query,clientId)  
  }

  onTextChange(e) {
    let {query} = this.state
    this.setState({query:e.target.value})
  }

  onTextSelect(e) {
    let {query} = this.state
    this.setState({query:e,isRange: false})
    this.loadData(this.state.year,this.state.month,e,this.state.clientId)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปค่าใช้จ่ายของรถลูกค้าแต่ละคัน.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    let {year,month,query,clientId} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCIncome&year='+year+'&month='+month+'&q='+query+'&cat='+clientId
    } else{
      url = './pdf/v2/?startPage=PrintReportKKCIncome&year='+year+'&month='+month+'&q='+query+'&cat='+clientId
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,this.state.query,this.state.clientId)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.query,this.state.clientId)
    }  
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.day+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            monthWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '180px', display: 'inline-block', marginLeft:'5px' }}>
          <SelectObject
            value={this.state.clientId}
            objectList={this.state.data.clientList}
            onChange={this.onClientChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <InputGroup>
            <CKAutocomplete
              placeholder="พิมพ์ชื่อค้นหา..."
              items={this.state.queryList}
              value={this.state.query}
              onChange={this.onTextChange.bind(this)}
              onSelect={this.onTextSelect.bind(this)}
            />
            <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}><FontAwesome name='search' /></InputGroup.Addon>
          </InputGroup>
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <Button className='btn btn-danger' onClick={()=>{this.setState({query:''})}}><FontAwesome name='eraser' />&nbsp;ลบคำค้น</Button>
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.query,this.state.clientId)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'สรุปรายการค่าใช้จ่ายของรถลูกค้าแต่ละคัน'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText

    return (
      <Box>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportKKCIncome.defaultProps = {
  show : false
}

export default ReportKKCIncome;





// WEBPACK FOOTER //
// ./src/view/report/ReportKKCIncome.js